import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import { InputCheckbox, TextFieldWithLabel, Typography } from 'shared/ui'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { useCallingStepsContext } from 'pages/settings/pages/compliance/pages/calling/context/callingStepsContext'
import { CommonNumbers } from 'pages/settings/pages/compliance/ui/CommonNumbers/CommonNumbers'

import { PageErrorAlert } from 'pages/settings/pages/compliance/ui/PageErrorAlert/PageErrorAlert'
import styles from './styles.module.scss'

export const Configure = observer(() => {
  const { id } = useParams()
  const {
    cnamCallerIdStore: {
      loading,
      callerName,
      isCallerNameValid,
      numbersStore,
      errorMessage,
      submitDisabled,
      isConfigureTermsChecked,
      handleSubmit,
      setCallerName,
      setPreassignedData,
      setIsConfigureTermsChecked,
    },
    stepsStore: { setTotalSteps },
  } = useCallingStepsContext()

  useEffect(() => {
    setTotalSteps(2)
    id && setPreassignedData(Number(id))
  }, [])

  return (
    <div className={styles.container}>
      <PageDescription>Specify a Caller ID and the numbers it is associated to</PageDescription>

      <PageErrorAlert errorMessage={errorMessage} marginTop={20} />

      <TextFieldWithLabel
        marginTop={5}
        marginBottom={-2.3}
        labelProps={{
          label: {
            text: 'Caller ID name',
          },
          questionTooltipProps: {
            width: 232,
            type: 'description',
            label: 'Enter the brand name you want to display as your Caller ID',
            desc: 'You can display up to 15 characters and will be vetted for appropriateness and relevance to your business.',
          },
        }}
        textFieldProps={{
          className: styles.textInput,
          value: callerName,
          onChange: setCallerName,
          InputProps: {
            placeholder: 'e.g. Salesmsg',
          },
        }}
        errorMessage={
          isCallerNameValid
            ? ''
            : 'Invalid CNAM name. CNAM name should always start with a letter. Only letters, numbers, periods, commas, and spaces are allowed.'
        }
        limit={15}
      />

      <CommonNumbers loading={loading} numbersStore={numbersStore} />

      <InputCheckbox
        className={styles.declaration}
        checked={isConfigureTermsChecked}
        onChecked={() => setIsConfigureTermsChecked(!isConfigureTermsChecked)}
        color='var(--content-primary-tertiary)'
        label={
          <>
            <Typography
              ariaLabel='declaration'
              variant='body-md-regular'
              tag='div'
              width={430}
              className={styles.declarationText}
            >
              I certify that the associated Business Profile is the originator of the phone calls
              and certify that the display name represents my business.
            </Typography>
          </>
        }
      />

      <NextButton
        text='Submit for review'
        disabled={submitDisabled}
        loading={loading}
        onClick={() => handleSubmit(id ? Number(id) : null)}
      />
    </div>
  )
})
